/**
 * Truncates a long string by keeping the start and end visible, replacing the middle with ellipsis.
 * @param str The string to truncate
 * @param maxLength Maximum length of the resulting string (default 50)
 * @param startLength Number of characters to keep at the start (default 25)
 * @param endLength Number of characters to keep at the end (default 20)
 * @returns The truncated string
 */
export const truncateMiddle = (str: string, maxLength = 50, startLength = 25, endLength = 20) => {
  if (str.length <= maxLength) return str;

  // Adjust startLength and endLength if they don't fit within maxLength with ellipsis
  if (startLength + endLength + 3 > maxLength) {
    // 3 is for the length of "..."
    const available = maxLength - 3;
    startLength = Math.ceil(available / 2);
    endLength = Math.floor(available / 2);
  }

  const start = str.slice(0, startLength);
  const end = str.slice(str.length - endLength);

  return `${start}...${end}`;
};

/**
 * Converts a camelCase string to Title Case with spaces.
 * @param str The camelCase string to convert
 * @returns The Title Case string with spaces
 * @example
 * camelCaseToTitleCase('googleAdsAccount') // Returns 'Google Ads Account'
 * camelCaseToTitleCase('emailAddress') // Returns 'Email Address'
 */
export const camelCaseToTitleCase = (str: string): string => {
  // Insert a space before all uppercase letters
  const result = str.replace(/([A-Z])/g, ' $1');
  // Capitalize the first letter and return
  return result.charAt(0).toUpperCase() + result.slice(1);
};
